// extracted by mini-css-extract-plugin
module.exports = {"alert":"FeedbackMsg_alert__2aRpS","info":"FeedbackMsg_info__3s2W6","closebtn":"FeedbackMsg_closebtn__3eArI","hide":"FeedbackMsg_hide__2GpHQ"};